import { render, staticRenderFns } from "./PolynomialViz.vue?vue&type=template&id=6e37ad14&scoped=true"
import script from "./PolynomialViz.vue?vue&type=script&lang=js"
export * from "./PolynomialViz.vue?vue&type=script&lang=js"
import style0 from "./PolynomialViz.vue?vue&type=style&index=0&id=6e37ad14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e37ad14",
  null
  
)

export default component.exports